import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { ViewerContextProvider } from "./Context/ViewerContext/ViewerContextProvider.tsx";
import { XktContextProvider } from "./Context/XktContext/XktContextProvider.tsx";
import { ThemeProvider } from "./components/theme-provider.tsx";
import { TooltipProvider } from "./components/ui/tooltip.tsx";

import "./i18n/i18n";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
        <XktContextProvider>
            <ViewerContextProvider>
                <ThemeProvider>
                    <TooltipProvider>
                        <App />
                    </TooltipProvider>
                </ThemeProvider>
            </ViewerContextProvider>
        </XktContextProvider>
    </BrowserRouter>
);
